

const POSPrint = ({
  tabletMode,
  cart,
  reciptDetails,
  totalPrice,
  orderType,
  orderId,
  mobile,
  tenderedAmount,
  selectedDiscount,
  apiResponsePrint,
}) => {
  const handlePrintAPI = (reciptDetails, item, fullAddress) => {
    let formattedAddress = "Not available";

    try {
      const addressObj = JSON.parse(item.address_json);
      const values = addressObj?.values || {};

      formattedAddress = [
        values.name,
        values.house_number,
        values.address,
        values.landmark_area,
        values.city,
        values.state,
        values.in_pin_code,
        `Ph: ${values.phone_number}`,
      ]
        .filter(Boolean)
        .join(", ")
        .replace(/,/g, ",&nbsp;");
    } catch (error) {
      console.error("Failed to parse address_json:", error);
    }

    const deliveryInfo =
      item.orderType === "homedelivery"
        ? `
        <p class="textSizeMid">
            Delivery Partner Name: ${item.delivery_person_name
          ? item.delivery_person_name
          : "Not assigned"
        }
        </p>
        <p class="textSizeMid">
            Delivery Partner Mobile No.: ${item.delivery_person_number
          ? item.delivery_person_number
          : "Not assigned"
        }
        </p>`
        : "";

    // 👉 This is the CONTENT for a single receipt (only the inner .container)
    const singleReceiptSection = `
      <div class="container">
        <div class="header">
          <p class="textSizeLarge" style="font-weight: 600;">${reciptDetails.business_name
      }</p>
          <p class="textSizeMid">${reciptDetails.address}</p>
          <p class="textSizeMid">PH: ${reciptDetails.phone_no}</p>
          <p class="textSizeMid">GST NO: ${reciptDetails.gst}</p>
          ${reciptDetails.fssaiNo
        ? `<p class="textSizeMid">FSSAI NO: ${reciptDetails.fssaiNo}</p>`
        : ""
      }
          <p class="textSizeLarge" style="font-weight: 600;">** INVOICE **</p>
        </div>

        <div class="header2">
          <p class="textSizeMid">Order No: ${item.daily_order_id
      } / ${item.orderid}</p>
          <p class="textSizeMid">Order Type: ${item.orderType}</p>

          ${!(
        item.customer_name?.toLowerCase() === "default" &&
        (item.customer_mobile === "+91 9999999999" ||
          item.customer_mobile === "+91999999999" ||
          item.customer_mobile === "91999999999" ||
          item.customer_mobile === "999999999")
      )
        ? `
            <p class="textSizeMid">Customer Name: ${item.customer_name}</p>
            <p class="textSizeMid">Customer Mobile: ${item.customer_mobile}</p>
          `
        : ""
      }

          ${item.billingName !== null && item.billingName !== ""
        ? `<p class="textSizeMid">Billing Name: ${item.billingName}</p>`
        : ""
      }

          ${item.billingGst !== "" && item.billingGst !== null
        ? `<p class="textSizeMid">Billing Gst: ${item.billingGst}</p>`
        : ""
      }

          ${item.billingAddress !== "" && item.billingAddress !== null
        ? `<p class="textSizeMid">Billing Address: ${item.billingAddress}</p>`
        : ""
      }

          <p class="textSizeMid">Payment Status: ${item.payment_status
      }</p>  
          <p class="textSizeMid">Payment Mode: ${item.payment_mode}</p>
          <p class="textSizeMid">Order Date: ${item.order_date}</p>

          ${item.orderType === "homedelivery"
        ? `<p class="textSizeMid">Delivery Address: ${formattedAddress}</p>`
        : ""
      }

          ${item.orderType === "dining"
        ? `<p class="textSizeMid">Table No: ${item.table_no}</p>`
        : ""
      }

          ${item.orderType === "room_order"
        ? `<p class="textSizeMid">Room No: ${item.table_no}</p>`
        : ""
      }
        </div>

        <div class="headerTable">
          <table class="order-details" style="border-collapse: collapse;">
            <thead>
              <tr>
                <th class="table-text-center" style="padding-right:5px;">Sr.</th>
                <th class="table-text-center">ITEM</th>
                <th class="table-text-center">QTY</th>
                <th class="table-text-center" style="padding-left:5px; padding-right:5px;">PRC.</th>
                <th class="table-text-center">TTL.</th>
              </tr>
            </thead>
            <tbody>
              ${item.items
        .map((subitem, index) => {
          let customizationText = "";

          try {
            const customization =
              subitem.customization && subitem.customization !== "{}"
                ? JSON.parse(subitem.customization)
                : null;

            if (Array.isArray(customization)) {
              const parts = customization.map((cItem) => {
                const options = Array.isArray(cItem.options)
                  ? cItem.options.join(", ")
                  : "";
                return ` ${options}`;
              });

              customizationText = parts.length
                ? `<div class="custom-text">(${parts.join(" | ")})</div>`
                : "";
            } else {
              customizationText = "";
            }
          } catch {
            customizationText = `<div class="custom-text">(Invalid customization)</div>`;
          }

          return `
                    <tr>
                      <td class="table-text-center">${1 + index}</td>
                      <td class="table-text-center">
                        ${subitem.item_name}
                        ${customizationText}
                      </td>
                      <td class="table-text-center" style="padding-left:5px;">
                        ${subitem.quantity}
                      </td>
                      <td class="table-text-center" style="padding-left:5px; padding-right:5px;">
                        ${parseFloat(subitem.item_price)}
                      </td>
                      <td class="table-text-center">
                        ${parseFloat(subitem.total_price)}
                      </td>
                    </tr>
                  `;
        })
        .join("")}
            </tbody>
          </table>
        </div>

        <div class="headerTotal">
          <div class="flex-row">
            <p class="textSizeMid" style="margin: 0px;">Sub Total :</p>
            <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${item.subtotal
      }</p>
          </div>

          ${item.discount_amount !== "0.00"
        ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Discount Amount (${item.discount_percentage
        }%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.discount_amount
        ).toFixed(2)}</p>
            </div>
          `
        : ""
      }

          ${item.coupon_applied
        ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Coupon discount :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.coupon_code_discount
        ).toFixed(2)}</p>
            </div>
          `
        : ""
      }

          ${Number(reciptDetails.taxCgst) > 0 ||
        Number(reciptDetails.taxSgst) > 0
        ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">CGST (${parseFloat(
          reciptDetails?.taxCgst || "0"
        ).toFixed(1)}%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.tax_cgst
        ).toFixed(2)}</p>
            </div>
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">SGST (${parseFloat(
          reciptDetails?.taxSgst || "0"
        ).toFixed(1)}%) :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.tax_sgst
        ).toFixed(2)}</p>
            </div>
          `
        : ""
      }

          ${item.orderType === "homedelivery"
        ? `
            <div class="flex-row">
              <p class="textSizeMid" style="margin: 0px;">Delivery Fee :</p>
              <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${item.delivery_fee
        }</p>
            </div>
          `
        : ""
      }

          <div class="flex-row font-weight-bold">
            <p class="textSizeMid" style="margin: 0px;font-weight: 600;">Total Amount :</p>
            <p class="textSizeMid" style="margin: 0px; text-align: right; font-weight: 600;">Rs. ${item.totalOrderPrice
      }</p>
          </div>
          
        </div>

        <div class="header2">
          <p class="textSizeMid">Net Amount : Rs. ${item.totalOrderPrice}</p>
          <p class="textSizeMid">Paid Amount : Rs. ${item.pay_amount}</p>
          <p class="textSizeMid">Due Amount : Rs. ${item.due_amount}</p>
        </div>

        <div class="headerEnd">
          <p class="textSizeMid">Thank you for your purchase!</p>
          <p class="textSizeSmall">* ${reciptDetails.tag_line1} *</p>
        </div>
      </div>
    `;

    // 👉 Now we wrap TWO copies of the same section with a page-break between them
    const customerReceiptHTML = `
      <html>
        <head>
          <style>
            @page {
              size: 80mm;
              margin: 0;
            }
            body {
              margin: 0;
              margin-right:15px;
              font-family: Arial, sans-serif;
              font-size: 16px;
              color: black;
            }
            .header {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              text-align: center;
              color: #000;
              line-height: 1.1;
              border-bottom: 1px dashed #000;
              margin-top: 0px;
            }
            .header2 {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: start;
              color: #000;
              line-height: 1.5;
              border-bottom: 1px dashed #000;
              margin-top: 0px;
              padding-bottom: 0px;
            }
            .headerTable {
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: start;
              color: #000;
              line-height: 1.2;
              border-bottom: 1px dashed #000;
              padding: 0;
              margin: 0;
            }
            .headerTotal {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              text-align: left;
              color: #000;
              line-height: 1.5;
              border-bottom: 1px dashed #000;
              padding-bottom: 5px;
              padding-top: 5px;
              padding:0px;
            }
            .flex-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }
            .headerEnd {
              text-align: center;
              color: #000;
              padding-bottom: 0px;
            }
            .textSizeLarge {
              font-size: 16px;
              margin: 1px;
              padding: 1px;
            }
            .textSizeMid {
              font-size: 12px;
              margin: 0px;
              padding: 0px;
            }
            .textSizeSmall {
              font-size: 9px;
              margin: 1px;
              padding: 1px;
            }
            .order-details { width: 100%; border-collapse: collapse; }
            .order-details th,
            .order-details td {
              padding: 0px;
              padding-top: 5px;
              padding-bottom: 5px;
              font-size: 12px;
              text-align: left;
              vertical-align: top;
            }
            .table-text-center { text-align: center; }
            .page-break {
              page-break-after: always;
            }
          </style>
        </head>
        <body>
          ${singleReceiptSection}
          <div class="page-break"></div>
          ${singleReceiptSection}
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(customerReceiptHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <>
      <button
        onClick={() => {
          if (Array.isArray(apiResponsePrint)) {
            if (apiResponsePrint.length > 0) {
              handlePrintAPI(reciptDetails, apiResponsePrint[0], "");
            } else {
              console.error("apiResponsePrint is an empty array.");
            }
          } else if (
            typeof apiResponsePrint === "object" &&
            apiResponsePrint !== null
          ) {
            handlePrintAPI(reciptDetails, apiResponsePrint, "");
          } else {
            console.error("apiResponsePrint is not valid.");
          }
        }}
        style={{ height: "120px", width: "250px" }}
        className={
          tabletMode
            ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
            : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
        }
      >
        PRINT
      </button>
    </>
  );
};

export default POSPrint;
